import { render, staticRenderFns } from "./freestyle-section.vue?vue&type=template&id=b7ff1792&scoped=true&"
import script from "./freestyle-section.vue?vue&type=script&lang=js&"
export * from "./freestyle-section.vue?vue&type=script&lang=js&"
import style0 from "./freestyle-section.vue?vue&type=style&index=0&id=b7ff1792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ff1792",
  null
  
)

export default component.exports